/* eslint-disable react/prop-types */
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { RiAlertFill, RiAlertLine } from 'react-icons/ri';

// eslint-disable-next-line import/prefer-default-export
export const getCertStateIcon = (tieneErrorSE) => {
  if (tieneErrorSE) {
    return (
      <RiAlertFill
        color="#FFFFFF"
        style={{
          backgroundColor: '#FF6666',
          height: '30px',
          width: '30px',
          borderRadius: '3px'
        }}
      />
    );
  }

  return <RiAlertLine color="#219E66" style={{ width: '30px', height: '30px' }} />;
};

export const getColumns = () => [
  {
    Header: 'Posición',
    accessor: 'posicion',
    hideSort: true,
    style: { fontWeight: 'bold' },
    Cell: ({ row }) => (
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={(props) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Tooltip id="button-tooltip" {...props}>
            {row?.original?.posicion}
          </Tooltip>
        )}
        placement="top"
      >
        <span>{row.original.posicion}</span>
      </OverlayTrigger>
    )
  },
  {
    Header: 'Línea',
    accessor: 'linea',
    hideSort: true,
    style: { fontWeight: 'bold' },
    Cell: ({ row }) => (
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={(props) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Tooltip id="button-tooltip" {...props}>
            {row?.original?.linea}
          </Tooltip>
        )}
        placement="top"
      >
        <span>{row.original.linea}</span>
      </OverlayTrigger>
    )
  },
  {
    Header: 'Cant. Reg.',
    hideSort: true,
    accessor: 'cantidadRegistrada',
    style: { fontWeight: 'bold' }
  },
  {
    Header: 'Cant. Cert.',
    hideSort: true,
    accessor: 'cantidadCertificada',
    style: { fontWeight: 'bold' }
  },
  {
    Header: 'PxQ',
    hideSort: true,
    accessor: 'pxQ',
    style: { fontWeight: 'bold' }
  },
  {
    Header: '',
    accessor: 'tieneErrorSE',
    hideSort: true,
    Cell: ({ value }) => (
      <button className="inspector_work_button_cert_state" type="button">
        {getCertStateIcon(value)}
      </button>
    ),
    style: {
      width: '50px'
    }
  }
];
